import { render, staticRenderFns } from "./indian-workforce.vue?vue&type=template&id=664db709&scoped=true&"
import script from "./indian-workforce.vue?vue&type=script&lang=js&"
export * from "./indian-workforce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664db709",
  null
  
)

export default component.exports